import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const EpilepsyPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Support for Epilepsy</h1>
        <section className="mb-8">
          <p>Epilepsy is a neurological condition characterized by recurrent seizures. It can affect anyone and often requires lifelong management. While medication is essential, natural therapies can support brain health and overall well-being.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Genetic factors</li>
            <li>Brain injury or trauma</li>
            <li>Infections affecting the brain</li>
            <li>Stroke</li>
            <li>Unknown causes (idiopathic)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Recurrent seizures</li>
            <li>Temporary confusion</li>
            <li>Staring spells</li>
            <li>Uncontrolled movements</li>
            <li>Loss of awareness</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We offer supportive herbal therapies and lifestyle guidance to help manage stress, improve sleep, and support brain function. Our approach is always complementary to your prescribed medical care.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Supports nervous system health</li>
            <li>Reduces stress and anxiety</li>
            <li>Promotes restful sleep</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a regular sleep schedule</li>
            <li>Practice stress reduction techniques</li>
            <li>Avoid known seizure triggers</li>
            <li>Eat a balanced diet</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal remedies replace epilepsy medication?</strong>
            <p>A: No, but they can support your overall health alongside your doctor's plan.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Are there any side effects?</strong>
            <p>A: Our herbal remedies are gentle and well-tolerated.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Is this safe for children?</strong>
            <p>A: Yes, with a customized approach for each individual.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Support your brain health—book a holistic epilepsy care consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default EpilepsyPage; 